import { render, staticRenderFns } from "./AppSvgContainer.vue?vue&type=template&id=37c7b907"
import script from "./AppSvgContainer.vue?vue&type=script&lang=js"
export * from "./AppSvgContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports